import { createSvgIcon } from 'shared/icons/IconUtils';

export const ClaimIcon = createSvgIcon(
  'Claim',
  <path
    fill="currentColor"
    d="M10.5938 13.0936C10.7535 12.9339 10.8333 12.7359 10.8333 12.4998C10.8333 12.2637 10.7535 12.0658 10.5938 11.9061C10.434 11.7464 10.2361 11.6665 10 11.6665C9.76389 11.6665 9.56597 11.7464 9.40625 11.9061C9.24653 12.0658 9.16667 12.2637 9.16667 12.4998C9.16667 12.7359 9.24653 12.9339 9.40625 13.0936C9.56597 13.2533 9.76389 13.3332 10 13.3332C10.2361 13.3332 10.434 13.2533 10.5938 13.0936ZM9.16667 9.99984H10.8333V5.83317H9.16667V9.99984ZM10 18.3332C8.06945 17.8471 6.4757 16.7394 5.21875 15.0103C3.96181 13.2811 3.33334 11.3609 3.33334 9.24984V4.1665L10 1.6665L16.6667 4.1665V9.24984C16.6667 11.3609 16.0382 13.2811 14.7813 15.0103C13.5243 16.7394 11.9306 17.8471 10 18.3332Z"
  />,
  { viewBox: '0 0 20 20' },
);
